// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/event-tile/event-tile.component.scss
// module id = 276
// module chunks = 0